import React from 'react';
import PropTypes from 'prop-types';

import * as styled from './styles';

function SimpleCardBubbleItem({ title, subtitle, image, label, route, link, linkAnchor }) {
  const linkTo = `${route ? route.slug.current : link}${linkAnchor || ''}`;

  return (
    <styled.SimpleCardBubbleItem>
      <styled.ImageWrapper>
        <styled.Image fluid={image.asset.fluid} altText={image.altText} />
      </styled.ImageWrapper>
      <styled.SimpleTitle levels={[300, 300]}>{title}</styled.SimpleTitle>
      <styled.SimpleSubtitle levels={[400, 400]}>{subtitle}</styled.SimpleSubtitle>
      {label && linkTo ?
        <styled.Link level={500} to={linkTo} key={title || linkTo}>{label}</styled.Link> : null}
    </styled.SimpleCardBubbleItem>
  );
}

SimpleCardBubbleItem.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  image: PropTypes.object,
  label: PropTypes.string,
  link: PropTypes.string,
  linkAnchor: PropTypes.string,
  route: PropTypes.shape({
    slug: PropTypes.shape({
      current: PropTypes.string,
    }),
  }),
};

export default SimpleCardBubbleItem;
